import axios from 'axios';

// TOPページ "お知らせ"の投稿を取得するための処理
document.addEventListener('DOMContentLoaded', function() {
	// TOPページのお知らせ一覧が存在する場合のみ処理を実行
	if (document.querySelector('.p-home__notice')) {
		const noticeContainer = document.getElementById('top_notice_list');
		const categoryButtons = document.querySelectorAll('.l-notice__categoryBtn'); // categoryButtonsを定義

		function fetchNotice(category = '') {
			let url = '/wp-json/custom/v1/notice';
			// カテゴリーでソートするためのパラメータを追加
      if (category) {
				// 指定カテゴリーのパラメータを追加しimportantカテゴリーを除外
        url += `?category=${category}&exclude_category=important`;
      } else {
				// importantカテゴリーを除外
        url += `?exclude_category=important`;
      }

			axios.get(url)
			.then(response => {
				const posts = response.data;
				noticeContainer.innerHTML = '';
				posts.forEach(post => {
					const postElement = document.createElement('li');
						postElement.classList.add('l-notice__item');

						// カテゴリーは登録された数ごとループするように個別の<span>要素を生成
						let categoriesItem = '';
						post.terms.forEach(term => {
							categoriesItem += `<span class="l-notice__category">${term}</span>`;
						});
						postElement.innerHTML = `
							<a class="l-notice__link c-arrowAnime" href="${post.link}">
								<div class="l-notice__heading">
									<time class="l-notice__date" datetime="${post.date}">${post.date.replace(/-/g, '.')}</time>
									${categoriesItem}
								</div>
								<p class="l-notice__title c-paragraph -sm">
									<span>${post.title}</span>
								</p>
								<span class="c-arrow -primary l-notice__icon"></span>
							</a>
					`;
					noticeContainer.appendChild(postElement);
				});
			})
			.catch(error => {
				console.error('Error fetching notice:', error);
			});
		}

		// 初期表示
		fetchNotice();

		// カテゴリーボタンのクリックイベントを設定
		categoryButtons.forEach(button => {
			button.addEventListener('click', function(event) {
				event.preventDefault();
				const category = this.getAttribute('data-category');
				fetchNotice(category);

				// 現在のカテゴリーボタンのクラスつけ外し
				categoryButtons.forEach(btn => btn.classList.remove('is-current'));
				this.classList.add('is-current');
			});
		});
	}
});
